import { IResponse } from "models";

export enum ActionType {
  VERIFY_OTP = "action/VERIFY_OTP",
  VERIFY_OTP_SUCCESS = "action/VERIFY_OTP_SUCCESS",
  VERIFY_OTP_ERROR = "action/VERIFY_OTP_ERROR",
  VERIFY_OTP_RESET = "action/VERIFY_OTP_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IVerifyOTPPayload {
  mobile_number: string;
  otp: string;
}

export interface IVerifyOTPResponse extends IResponse {
  result: any;
}
